import React from "react";
import { useTranslation } from "react-i18next";

import betwayLogo from "../../assets/betway-logo.png";
import styles from "./BetwayAccountFragment.module.css";
import { openExternalUrl, openExternalUrlAndroid } from "../../utils/externalUrlHandler";

const BetwayAccountFragment = () => {
	const { t } = useTranslation();

	const handleOpenBetwayAccount = () => {
		// Check if Android WebView is available first
		if (window.Android && typeof window.Android.openExternal === "function") {
			// Android WebView - only call Android function
			openExternalUrlAndroid();
		} else {
			// iOS WebView or regular browser - call iOS function (with fallback)
			openExternalUrl();
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<div className={styles.logoContainer}>
					<img src={betwayLogo} alt="Betway" className={styles.logo} />
				</div>

				<h2 className={styles.title}>{t("betwayAccount.title")}</h2>

				<div className={styles.content}>
					<p className={styles.description}>{t("betwayAccount.description")}</p>

					<p className={styles.rulesText}>{t("betwayAccount.rulesText")}</p>
				</div>

				<div className={styles.buttonContainer}>
					<button className={styles.openAccountButton} onClick={handleOpenBetwayAccount}>
						{t("betwayAccount.button")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default BetwayAccountFragment;
